// extracted by mini-css-extract-plugin
export default {"svg-image-source":"r3mRED","svgImageSource":"r3mRED","svg-image-root":"vM3LYh","svgImageRoot":"vM3LYh"};